/* eslint-disable no-lone-blocks */
import { Bell } from 'lucide-react'
import { MdMenu, MdNewReleases } from 'react-icons/md'
import { FaWhatsapp } from 'react-icons/fa'
import { Link } from 'react-router-dom'

import { useVersionStore } from '@/modules/docs/stores/version-store'
import { homeDrawerFields } from '@/modules/shared/constants/drawer-fields'

import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetTitle,
	SheetFooter,
	SheetHeader,
	SheetTrigger,
} from '../../../modules/shared/components/ui/sheet'
import { useAuth } from '../hooks/use-auth'
import { useAuthStore } from '../stores/auth.store'
import { Button } from './ui/button'

type MenuDrawerProps = {
	nameCompany: string
	nameSeller: string
	versionApp: string
}

export function MenuDrawer({
	nameCompany,
	nameSeller,
	versionApp,
}: MenuDrawerProps) {
	const { hasNewVersion } = useVersionStore()
	const nivelAcesso = useAuthStore((state) => state.nivelAcesso)
	const visibleDrawerFields = homeDrawerFields.filter(
		(item) => nivelAcesso === undefined || !item.hiddenForLevels.includes(nivelAcesso),
	)

	const { logout } = useAuth()
	return (
		<Sheet>
			<SheetTrigger asChild className="cursor-pointer">
				<div className="cursor-pointer p-4 ">
					<MdMenu className="text-foreground" size={24} />
				</div>
			</SheetTrigger>
			<SheetContent
				side="left"
				className="flex justify-between flex-col text-md text-md"
			>
				<div className="sr-only">
					<SheetTitle>Menu principal</SheetTitle>
					<SheetDescription>
						Acesse as opções disponíveis, notas de versão, suporte e informações da empresa.
					</SheetDescription>
				</div>
				<SheetHeader>
					<div className="mt-6">
						<ol className="m-0 list-none">
							<div className="items-start ">
								{visibleDrawerFields.map((item) => (
									<li className="w-full" key={item.id}>
										<Link to={item.route}>
											<div className="flex items-center mb-5 space-x-2">
												<item.icon color="#D72736" size={22} />
												<p className="text-foreground">{item.valueItem}</p>
											</div>
										</Link>
									</li>
								))}

								<li className="w-full">
									<Link to="/atualizacoes">
										<div className="flex items-center mb-6 space-x-2">
											<div className="relative">
												<MdNewReleases color="#D72736" size={24} />
												{hasNewVersion && (
													<Bell
														size={14}
														className="absolute text-center fill-yellow-400 animate-shake text-yellow-300 top-0 -right-2"
													/>
												)}
											</div>
											<p className="text-foreground">Notas de versão</p>
										</div>
									</Link>
								</li>

								<li className="w-full">
									<a href="https://wa.me/5519999092119" target="_blank" rel="noopener noreferrer">
										<div className="flex items-center mb-5 space-x-2">
											<FaWhatsapp color="#25D366" size={22} />
											<p className="text-foreground">Suporte WhatsApp</p>
										</div>
									</a>
								</li>

								<div className="flex items-center space-x-2 mb-4 ml-auto" />
							</div>
						</ol>
					</div>
				</SheetHeader>
				<SheetFooter>
					<div className="w-full text-foreground">
						<div className="mb-6 text-sm">
							<p className="font-semibold">{nameCompany}</p>

							<p className="font-semibold">{nameSeller}</p>

							<p>{`VERSÃO: ${versionApp}`}</p>
						</div>

						<Button className="w-full bg-primary" onClick={logout}>
							Sair
						</Button>
					</div>
				</SheetFooter>
			</SheetContent>
		</Sheet>
	)
}